import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useSession } from "../lib/session.tsx";

interface Props {
  children: ReactNode;
}

export function ProtectedRoute({ children }: Props) {
  const { data: session, isPending } = useSession();

  if (isPending) {
    return (
      <div className="auth-page">
        <div className="loading-stack">
          <span className="spinner spinner-lg" />
          <p>Loading…</p>
        </div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
